import { CCol, CFormGroup, CInputRadio, CLabel, CRow } from "@coreui/react";
import React, { Fragment } from "react";

export const RegisterCustomSelect = ({ id, name, value, label, onChange, precio, Plan }) => {


  return (

    <CFormGroup
      variant="checkbox"
      name={name}
      style={{
        padding: "7px 15px",
        border:
          parseInt(id) === value ? "2px solid #673de6" : "1px solid rgb(218, 217, 218)",
        margin: "9px 0 5px 0",
        borderRadius: "4px",
        background: parseInt(id) === 0 ? "rgb(213 211 227)" : "",
        fontWeight: parseInt(id) === 0 ? "bold" : ""
      }}
      onClick={() => onChange({ target: { name, value: parseInt(id) } })}
    >
      <CRow
        style={{
          marginLeft: 0,
          marginRight: 0,
          marginTop: 10,
          marginBottom: 5,
        }}
      >
        <Fragment>
          <CCol md="12">
            <CInputRadio
              className="form-check-input"
              id={id}
              name="radios"
              value="option1"
              checked={parseInt(id) === parseInt(value)}
            />
            <CLabel variant="checkbox" htmlFor="radio1">
              {label}
            </CLabel>
          </CCol>
        </Fragment>
      </CRow>
    </CFormGroup>

  );
};



export const RegisterCustomSelectPais = ({ id, name, value, label, onChange }) => {


  return (

    <CFormGroup
      variant="checkbox"
      name={name}
      style={{
        padding: "7px 15px",
        border:
          parseInt(id) === parseInt(value) ? "2px solid #673de6" : "1px solid rgb(218, 217, 218)",
        margin: "9px 0 5px 0",
        borderRadius: "4px",
        background: parseInt(id) === 0 ? "rgb(213 211 227)" : "",
        fontWeight: parseInt(id) === 0 ? "bold" : ""
      }}
      onClick={() => onChange({ target: { name, value: parseInt(id) } })}
    >
      <CRow
        style={{
          marginLeft: 0,
          marginRight: 0,
          marginTop: 10,
          marginBottom: 5,
        }}
      >
        <Fragment>
          <CCol md="12">
            <CInputRadio
              className="form-check-input"
              id={id}
              name={name}
              value="option1"
              checked={parseInt(id) === parseInt(value)}
            />

            <CLabel variant="checkbox" htmlFor="radio1">
              <img src={`https://cdn.ipwhois.io/flags/${id === 1 ? 'do' : id === 2 ? 'gt' : id === 3 ? 'hn' : 'otr'}.svg`} style={{ width: 25, marginLeft: 10, marginRight: 10 }} alt=""></img>

              {label}
            </CLabel>
          </CCol>
        </Fragment>
      </CRow>
    </CFormGroup>

  );
};